import React from "react";
import { useNavigate } from "react-router-dom";
import aboutImg from "../../assets/images/lailaImg.png";
import PrimaryButton from "../common/PrimaryButton";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="flex overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <div className="py-6 sm:py-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
        <div className="">
          <img src={aboutImg} alt="" />
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="jost-regular text-xl sm:text-2xl text-primary py-4 uppercase">
            About psyche ethos
          </h3>
          <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
            Take care of your mind. Explore our{" "}
            <span className="italic font-eiko-thin">psychology</span> section!
          </h1>
          <p className="max-w-2xl opacity-50">
            Psyche Ethos, a company committed to inspiring and supporting the
            journey to wellness for organisations, communities or individuals.
            This is achieved through combining intuitive and analytical
            approaches, utilising customised frameworks to creatively problem
            solve for barriers to balance, harmony and sustainable wellness. We
            enable our customers to flourish in their personal and professional
            lives by assisting them in developing long-lasting methods for
            peace, equilibrium. and general well-being through our custom
            remedies.
          </p>
          <PrimaryButton
            onClick={() => navigate("/services")}
            className="w-[210px] uppercase mt-4 sm:mt-6"
            icon
          >
            Learn more
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default About;
